// extracted by mini-css-extract-plugin
export var barContainer = "_4o-0";
export var extraThin = "_4o-3";
export var fillBar = "_4o-6";
export var fillContainer = "_4o-4";
export var overflow = "_4o-8";
export var overflowContainer = "_4o-5";
export var regular = "_4o-7";
export var thick = "_4o-1";
export var thin = "_4o-2";